import React from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Pagination from "@amzn/meridian/pagination";
import Row from "@amzn/meridian/row";
import Select, { SelectOption } from "@amzn/meridian/select";

export interface ITableFooterProps {
    setCurrentPage: (value) => void;
    currentPage: number;
    numberOfPages: number;
    setPageSize: (value) => void;
    pageSize: any;
}

export const TableFooter: React.FC<ITableFooterProps> = ({
    setCurrentPage,
    currentPage,
    numberOfPages,
    setPageSize,
    pageSize,
}) => {
    return (
        <Row width="100%" widths={["fit", "fit", "fill", "fit"]}>
            <Box>
                <Text>Results per page</Text>
            </Box>
            <Box>
                <Select value={pageSize.toString()} onChange={setPageSize}>
                    <SelectOption value="5" label="5 items" />
                    <SelectOption value="10" label="10 items" />
                    <SelectOption value="20" label="20 items" />
                </Select>
            </Box>
            <div />
            <Pagination
                showSkipArrows={true}
                numberOfPages={numberOfPages}
                onChange={e => setCurrentPage(Number(e))}
                currentPage={currentPage}
            />
        </Row>
    );
};
